/* Widgeteer — Shipping policy page.
   Progressive enhancement only: the page is complete and usable without it.
   Copies a contact value (the returns address) to the clipboard.
   Re-runs when a section is reloaded in the theme editor. */
(function () {
  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-sp-copy]');
    for (var i = 0; i < buttons.length; i++) setup(buttons[i]);
  }

  function setup(btn) {
    if (btn.dataset.spReady === '1') return;
    btn.dataset.spReady = '1';

    var label = btn.querySelector('span');
    var status = btn.parentNode ? btn.parentNode.querySelector('.sp-status') : null;
    var source = document.getElementById(btn.getAttribute('data-sp-copy'));
    var done_label = btn.getAttribute('data-sp-done') || 'Address copied';
    var fail_label = btn.getAttribute('data-sp-fail') || 'Please copy manually';
    var idle_label = label ? label.textContent : '';
    var timer;

    if (!source) return;

    function done(ok) {
      if (status) {
        status.textContent = ok
          ? 'Address copied to clipboard.'
          : 'Copy unavailable — please select the address above.';
      }
      if (label) label.textContent = ok ? done_label : fail_label;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (label) label.textContent = idle_label;
        if (status) status.textContent = '';
      }, 2500);
    }

    function fallback(text) {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'absolute';
      t.style.left = '-9999px';
      document.body.appendChild(t);
      t.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      done(ok);
    }

    btn.addEventListener('click', function () {
      var text = source.innerText.replace(/\u00a0/g, ' ').trim();
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () { done(true); }, function () { fallback(text); });
      } else {
        fallback(text);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
